import Vue from 'vue';
import Vuex from 'vuex';
import toolConfigurationModule from '@/store/modules/toolConfigurartion';
import presentsConfigurationModule from '@/store/modules/presents';
import typeLevelModule from '@/store/modules/levelType';
import answerConfigurationModule from '@/store/modules/answer';
import iconModule from '@/store/modules/icons';
import jobEvaluationModule from '@/modules/job-evaluation/store/index';
import actions from './actions';
import getters from './getters';
import mutations from './mutations';
import helper from '../shared/helper';
import vuexLocal from './persist';

Vue.use(Vuex);
const store = new Vuex.Store(
	{
		modules: {
			answer: { namespaced: true, ...answerConfigurationModule },
			icon: { namespaced: true, ...iconModule },
			levelType: { namespaced: true, ...typeLevelModule },
			presentsConfiguration: { namespaced: true, ...presentsConfigurationModule },
			tool: { namespaced: true, ...toolConfigurationModule },
			jobEvaluation: { namespaced: true, ...jobEvaluationModule },
		},
		state: {
			appConfig: {
				isLoading: false,
				snackbar: {
					text: '',
					isVisible: false,
					color: 'primary',
				},
			},
			sideBarRoutes: {},
			pollData: {
				progress: 0,
			},
			token: helper.getLocalToken(),
			user: {
				email: '',
				logo: 'praktiko-logo.svg',
				profileImage: '',
				username: '',
				isEployee: false,
			},
		},
		actions,
		getters,
		mutations,
		plugins: [vuexLocal.plugin],
	},
);

export default store;



// WEBPACK FOOTER //
// ./src/store/index.js